module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-end-btn-fill-c91b62b8.svg";